<div class="loading-indicator loader-hbs loading-hbs">
    <div class="loader-w" data-i18n="dashboard_loading">
        Loading
    </div>
</div>